const list = (value) => (Array.isArray(value) ? value : []);

export const normalizeMentors = (data) => ({
    ...data,
    MentorHistory: {
        ...data?.MentorHistory,
        Training: list(data?.MentorHistory?.Training),
        TheCloneWars: list(data?.MentorHistory?.TheCloneWars),
        SurvivingThePurge: list(data?.MentorHistory?.SurvivingThePurge),
    },
    MentorPersonality: list(data?.MentorPersonality),
    MentorComplications: list(data?.MentorComplications),
    MentorForceTraditions: list(data?.MentorForceTraditions),
});

export const mentorSelection = (entries, stored, field) => {
    if (!stored) { return ""; }
    if (entries[stored.Index]?.[field] === stored[field]) { return stored.Index; }
    const found = entries.findIndex((entry) => entry[field] === stored[field]);
    return found >= 0 ? found : "";
};

export const drawbackCost = (tradition) => Number(tradition?.Drawback?.Cost) || 0;

export const numericInput = (value) => (value === "" ? "" : Number(value));
